export const uz = {
  // Common
  common: {
    loading: 'Yuklanmoqda...',
    error: 'Xatolik',
    save: 'Saqlash',
    cancel: 'Bekor qilish',
    delete: 'O\'chirish',
    edit: 'Tahrirlash',
    create: 'Yaratish',
    add: 'Qo\'shish',
    update: 'Yangilash',
    search: 'Qidirish',
    clear: 'Tozalash',
    close: 'Yopish',
    confirm: 'Tasdiqlash',
    yes: 'Ha',
    no: 'Yo\'q',
    actions: 'Amallar',
    status: 'Holat',
    date: 'Sana',
    name: 'Nomi',
    description: 'Tavsif',
    amount: 'Miqdor',
    price: 'Narx',
    total: 'Jami',
    showing: 'Ko\'rsatilmoqda',
    of: 'dan',
    noData: 'Ma\'lumot topilmadi',
    all: 'Barchasi',
    dismiss: 'Yopish',
    created: 'Yaratilgan',
    updated: 'Yangilangan',
    deleting: 'O\'chirilmoqda...',
    saving: 'Saqlanmoqda...',
    saveChanges: 'O\'zgarishlarni saqlash',
    deleted: 'O\'chirilgan',
    areYouSure: 'Ishonchingiz komilmi?',
  },

  // Navigation
  nav: {
    dashboard: 'Boshqaruv paneli',
    companyExpenses: 'Kompaniya xarajatlari',
    personalExpenses: 'Shaxsiy xarajatlar',
    workers: 'Ishchilar',
    customers: 'Mijozlar',
    orders: 'Buyurtmalar',
    products: 'Mahsulotlar',
    sell: 'Sotuvlar',
    materials: 'Materiallar',
    materialIncomes: 'Material kirimlar',
    pricing: 'Narxlash',
    profile: 'Profil',
    admin: 'Admin',
  },

  // User menu
  userMenu: {
    upgradeToPro: 'Pro versiyaga yangilash',
    account: 'Hisob',
    billing: 'To\'lov',
    notifications: 'Bildirishnomalar',
    logout: 'Chiqish',
  },

  // Login
  login: {
    title: 'Hisobingizga kiring',
    subtitle: 'Kirish uchun elektron pochtangizni kiriting',
    email: 'Elektron pochta',
    password: 'Parol',
    forgotPassword: 'Parolni unutdingizmi?',
    loginButton: 'Kirish',
    loggingIn: 'Kirilmoqda...',
    emailPlaceholder: 'm@misol.com',
  },

  // Dashboard
  dashboard: {
    title: 'Boshqaruv paneli',
    activeWorkers: 'Faol ishchilar',
    pending: 'kutilmoqda',
    inactive: 'faol emas',
    newOrders: 'Yangi buyurtmalar',
    inProgress: 'jarayonda',
    completed: 'bajarildi',
    totalCustomerDebt: 'Mijozlarning umumiy qarzi',
    totalGiven: 'Jami berilgan',
    productsThisWeek: 'Bu haftadagi mahsulotlar',
    period: 'Davr',
    workerRanking: 'Ishchilar reytingi',
    byTotalProducts: 'Ishlab chiqarilgan mahsulotlar bo\'yicha',
    orders: 'buyurtmalar',
    products: 'mahsulotlar',
    noWorkerData: 'Ishchi ma\'lumotlari mavjud emas',
    topDebtors: 'Eng katta qarzdorlar',
    totalAmount: 'Jami summa',
    noDebtorsFound: 'Qarzdorlar topilmadi',
    materialsStock: 'Materiallar ombori',
    currentInventory: 'Hozirgi zaxira darajasi',
    noMaterialsInStock: 'Omborda material yo\'q',
    ordersOverview: 'Buyurtmalar sharhi',
    currentOrderStatus: 'Buyurtmalar holatining tahlili',
    new: 'Yangi',
    cancelled: 'Bekor qilindi',
    monthlyExpenses: 'Oylik xarajatlar',
    expenseSummary: 'Oy bo\'yicha xarajatlar xulosasi',
    noExpenseData: 'Xarajat ma\'lumotlari mavjud emas',
    budgetOverview: 'Byudjet',
    companyFinances: 'Kompaniya moliyasi',
    income: 'Daromad',
    inventoryValue: 'Zaxira qiymati',
    totalCompanyValue: 'Kompaniyaning umumiy qiymati',
    materialsValue: 'Materiallar qiymati',
    productsValue: 'Mahsulotlar qiymati',
  },

  // Workers
  workers: {
    title: 'Ishchilar',
    totalWorkers: 'Jami ishchilar',
    totalProfit: 'Jami foyda',
    totalPaid: 'Jami to\'langan',
    priceReferences: 'Katak narxlari',
    noPriceReferences: 'Katak narxlari topilmadi',
    square: 'Katak',
    manageWorkers: 'Ishchilar ma\'lumotlarini boshqarish va ko\'rish',
    searchPlaceholder: 'Ism yoki email bo\'yicha qidirish...',
    allStatus: 'Barcha holatlar',
    accepted: 'Qabul qilindi',
    pending: 'Kutilmoqda',
    rejected: 'Rad etildi',
    inactive: 'Faol emas',
    worker: 'Ishchi',
    received: 'Qabul qilindi',
    balance: 'Balans',
    joined: 'Qo\'shilgan',
    noWorkersFound: 'Ishchilar topilmadi.',
    noWorkersMatch: 'Filtrlarga mos ishchilar topilmadi.',
    showingWorkers: '{{count}} dan {{total}} ishchi ko\'rsatilmoqda',
    pendingApproval: 'Tasdiqlash kutilmoqda',
    priceRefDetails: 'Narx ma\'lumotnomasi tafsilotlari',
    updateOrDelete: 'Ushbu narx ma\'lumotnomasini yangilash yoki o\'chirish',
    enterSquare: 'Katak qiymatini kiriting',
    enterPrice: 'Narxni kiriting',
    updating: 'Yangilanmoqda...',
    updatePriceRef: 'Narx ma\'lumotnomasini yangilash',
    deletePriceRef: 'Narx ma\'lumotnomasini o\'chirish',
    deleting: 'O\'chirilmoqda...',
    areYouSure: 'Ishonchingiz komilmi?',
    deleteConfirmation: 'Bu amalni bekor qilib bo\'lmaydi. "{{square}}" katak uchun narx ma\'lumotnomasi butunlay o\'chiriladi.',
    amountOwed: 'Ishchiga to\'lanishi kerak bo\'lgan summa',
    workerOwes: 'Ishchi bu summani to\'lashi kerak',
    createPriceRef: 'Narx ma\'lumotnomasini yaratish',
    createPriceRefDesc: 'Yangi narx ma\'lumotnomasini qo\'shish',
    // Worker Detail page
    backToWorkers: 'Ishchilarga qaytish',
    pendingApprovalRequired: 'Tasdiqlash kerak',
    pendingApprovalDesc: 'Bu ishchi tasdiqlashni kutmoqda. Iltimos, uning ma\'lumotlarini ko\'rib chiqing va hisobini tasdiqlang yoki rad eting.',
    approveWorker: 'Ishchini tasdiqlash',
    reject: 'Rad etish',
    receivedAmount: 'Olingan summa',
    statusManagement: 'Holat boshqaruvi',
    workerStatus: 'Ishchi holati',
    changeStatusHint: 'Ishchining ruxsati va ko\'rinishini boshqarish uchun holatini o\'zgartiring.',
    timestamps: 'Vaqt belgilari',
    lastUpdated: 'Oxirgi yangilanish',
    workerNotFound: 'Ishchi topilmadi',
    productsDescription: 'Ushbu ishchi tomonidan ishlab chiqarilgan barcha mahsulotlar',
    noProducts: 'Mahsulotlar topilmadi',
    issueSalary: 'Maosh berish',
    issueSalaryDesc: 'Ishchiga maosh berish',
    amount: 'Summa',
  },

  // Customers
  customers: {
    title: 'Mijozlar',
    totalCustomers: 'Jami mijozlar',
    totalGiven: 'Jami berilgan',
    totalOwed: 'Jami qarz',
    manageCustomers: 'Mijozlar ma\'lumotlarini boshqarish va ko\'rish',
    addCustomer: 'Mijoz qo\'shish',
    createCustomer: 'Mijoz yaratish',
    createCustomerDesc: 'Yangi mijoz yozuvini yaratish',
    fullName: 'To\'liq ism',
    enterFullName: 'To\'liq ismni kiriting',
    phoneNumber: 'Telefon raqami',
    searchPlaceholder: 'Ism yoki telefon bo\'yicha qidirish...',
    given: 'Berilgan',
    owed: 'Qarz',
    noCustomersFound: 'Mijozlar topilmadi.',
    noCustomersMatch: 'Filtrlarga mos mijozlar topilmadi.',
    showingCustomers: '{{count}} dan {{total}} mijoz ko\'rsatilmoqda',
    creating: 'Yaratilmoqda...',
    // Customer Detail page
    backToCustomers: 'Mijozlarga qaytish',
    totalPaidByCustomer: 'Mijoz tomonidan to\'langan jami summa',
    amountOwed: 'Qarz summasi',
    remainingBalance: 'To\'lanishi kerak bo\'lgan qoldiq',
    totalOrders: 'Jami buyurtmalar',
    ordersPlaced: 'Joylashtirilgan buyurtmalar soni',
    contactInfo: 'Aloqa ma\'lumotlari',
    timestamps: 'Vaqt belgilari',
    created: 'Yaratilgan',
    lastUpdated: 'Oxirgi yangilanish',
    customerNotFound: 'Mijoz topilmadi',
    customerNotFoundDesc: 'Siz qidirayotgan mijoz mavjud emas yoki o\'chirilgan bo\'lishi mumkin.',
    editCustomer: 'Mijozni tahrirlash',
    updateCustomerInfo: 'Mijoz ma\'lumotlarini yangilash',
    deleteCustomer: 'Mijozni o\'chirish',
    deleteCustomerConfirmation: '"{{name}}" mijozini o\'chirmoqchimisiz? Bu amalni bekor qilib bo\'lmaydi.',
    ordersDescription: 'Ushbu mijoz tomonidan berilgan barcha buyurtmalar',
    noOrders: 'Buyurtmalar topilmadi',
    addIncome: 'To\'lov qo\'shish',
    addIncomeDesc: 'Mijozd yangi to\'lovni ro\'yxatga olish',
    addDebt: 'Qarz qo\'shish',
    addDebtDesc: 'Mijoz qarzini ro\'yxatga olish',
    invalidDebtAmount: 'Summa nol yoki manfiy bo\'lishi mumkin emas',
    amount: 'Summa',
    boughtProducts: 'Sotib olingan mahsulotlar',
    boughtProductsDescription: 'Ushbu mijoz tomonidan sotib olingan barcha mahsulotlar',
    noBoughtProducts: 'Mahsulotlar topilmadi',
  },

  // Orders
  orders: {
    title: 'Buyurtmalar',
    totalOrders: 'Jami buyurtmalar',
    totalRevenue: 'Jami daromad',
    totalPaid: 'Jami to\'langan',
    pendingOrders: 'Kutilayotgan buyurtmalar',
    manageOrders: 'Barcha buyurtmalarni ko\'rish va boshqarish',
    searchPlaceholder: 'Mijoz, telefon yoki material bo\'yicha qidirish...',
    allStatuses: 'Barcha holatlar',
    new: 'Yangi',
    inProgress: 'Jarayonda',
    completed: 'Bajarildi',
    cancelled: 'Bekor qilindi',
    client: 'Mijoz',
    dimensions: 'O\'lchamlar',
    paid: 'Oldindan berilgan',
    noOrdersFound: 'Buyurtmalar topilmadi.',
    noOrdersMatch: 'Filtrlarga mos buyurtmalar topilmadi.',
    showingOrders: '{{count}} dan {{total}} buyurtma ko\'rsatilmoqda',
    filterByStatus: 'Holat bo\'yicha filtrlash',
    orderNumber: 'Buyurtma #{{id}}',
    editOrder: 'Buyurtmani tahrirlash',
    updateOrderInfo: 'Buyurtma ma\'lumotlarini yangilash',
    amountDue: 'To\'lanishi kerak',
    fullyPaid: 'To\'liq to\'langan',
    createOrder: 'Buyurtma yaratish',
    dimensionsHint: 'Format: sim katak balandlik kenglik miqdor (masalan: 2 40 1.5 10 40)',
    selectClient: 'Mijozni tanlang',
    enterClientName: 'Mijoz ismini kiriting',
    color: 'Rang',
    selectColor: 'Rangni tanlang',
    wireType: 'Sim turi',
    selectWireType: 'Sim turini tanlang',
    sellingType: 'Sotish turi',
    selectSellingType: 'Sotish turini tanlang',
    profit: 'Foyda',
    prePayment: 'Oldindan to\'lov',
    optional: 'Ixtiyoriy',
    changeType: 'O\'zgartirish turi',
    discount: 'Chegirma',
    markup: 'Ustama',
    setDeadline: 'Muddatni belgilash',
    deadline: 'Muddat',
    // Order Detail page
    backToOrders: 'Buyurtmalarga qaytish',
    fullPrice: 'To\'liq narx',
    leftPrice: 'Qoldiq to\'lov',
    unitPrice: 'Birlik narxi',
    remaining: 'Qoldiq',
    progress: 'Jarayon',
    itemsCompleted: 'Bajarilgan buyurtmalar',
    clientInformation: 'Mijoz ma\'lumotlari',
    fullName: 'To\'liq ism',
    phoneNumber: 'Telefon raqami',
    materialDetails: 'Material tafsilotlari',
    material: 'Material',
    thickness: 'qalinlik',
    dimensionsAndQuantity: 'O\'lchamlar va miqdor',
    width: 'Kenglik',
    height: 'Balandlik',
    square: 'Katak',
    quantity: 'Miqdor',
    weightInformation: 'Og\'irlik ma\'lumotlari',
    currentWeight: 'Hozirgi og\'irlik',
    requiredWeight: 'Kerakli og\'irlik',
    createdBy: 'Yaratuvchi',
    name: 'Ism',
    email: 'Email',
    role: 'Lavozim',
    timestamps: 'Vaqt belgilari',
    created: 'Yaratilgan',
    lastUpdated: 'Oxirgi yangilanish',
    assignedWorkers: 'Tayinlangan ishchilar',
    orderNotFound: 'Buyurtma topilmadi',
    orderNotFoundDesc: 'Siz qidirayotgan buyurtma mavjud emas yoki o\'chirilgan bo\'lishi mumkin.',
    deleteConfirmTitle: 'Ishonchingiz komilmi?',
    deleteConfirmDesc: 'Bu amalni bekor qilib bo\'lmaydi. Buyurtma #{{id}} butunlay o\'chiriladi.',
    doneQuantity: 'Bajarilgan miqdor',
    selectStatus: 'Holatni tanlang',
    status: 'Holat',
    createdAt: 'Yaratilgan',
    price: 'Narx',
  },

  // Products
  products: {
    title: 'Mahsulotlar kirimi',
    type: 'Turi',
    quantity: 'Miqdor',
    productTypes: 'Mahsulot turlari',
    totalCount: 'Jami soni',
    totalWeight: 'Jami og\'irlik',
    productQuantities: 'Mahsulot miqdorlari',
    viewInventory: 'Material va o\'lcham bo\'yicha guruhlangan mahsulotlar inventarizatsiyasini ko\'rish',
    searchPlaceholder: 'Material, o\'lchamlar bo\'yicha qidirish...',
    allMaterials: 'Barcha materiallar',
    material: 'Material',
    square: 'Katak',
    height: 'Balandlik (m)',
    width: 'Kenglik (m)',
    count: 'Soni',
    weight: 'Og\'irlik',
    noProductsFound: 'Mahsulotlar topilmadi.',
    noProductsMatch: 'Filtrlarga mos mahsulotlar topilmadi.',
    showingProducts: '{{count}} dan {{total}} mahsulot turi ko\'rsatilmoqda',
    inventory: 'Ombor',
    inventoryDescription: 'Material va o\'lcham bo\'yicha guruhlangan mahsulotlar miqdori',
    thickness: 'Qalinlik',
    color: 'Rang',
    cell: 'Katak',
    allThicknesses: 'Barcha qalinliklar',
    dimensions: 'O\'lchamlar',
    workerPrice: 'Ishchi narxi',
    createdAt: 'Yaratilgan',
    fullWeight: 'Umumiy og\'irlik',
    mustWeight: 'Kerakli og\'irlik',
  },

  // Materials
  materials: {
    title: 'Materiallar',
    totalMaterials: 'Jami materiallar',
    totalWeight: 'Jami og\'irlik',
    materialTypes: 'Material turlari',
    materialsTab: 'Materiallar',
    colorsTab: 'Ranglar',
    wireTypesTab: 'Sim turlari',
    manageInventory: 'Material inventarizatsiyasini boshqarish va ko\'rish',
    searchPlaceholder: 'Nom, rang yoki tur bo\'yicha qidirish...',
    allColors: 'Barcha ranglar',
    allTypes: 'Barcha turlar',
    type: 'Turi',
    color: 'Rang',
    thickness: 'Qalinlik',
    noMaterialsFound: 'Materiallar topilmadi.',
    noMaterialsMatch: 'Filtrlarga mos materiallar topilmadi.',
    showingMaterials: '{{count}} dan {{total}} material ko\'rsatilmoqda',
    colors: 'Ranglar',
    viewColors: 'Mavjud material ranglarini ko\'rish',
    addColor: 'Rang qo\'shish',
    addNewColor: 'Yangi rang qo\'shish',
    createColor: 'Yangi material rangi yaratish',
    colorName: 'Rang nomi',
    colorPlaceholder: 'masalan, Qizil, Ko\'k',
    noColorsFound: 'Ranglar topilmadi.',
    totalColors: 'Jami: {{count}} rang',
    wireTypes: 'Sim turlari',
    viewWireTypes: 'Mavjud sim turlarini ko\'rish',
    addWireType: 'Sim turi qo\'shish',
    addNewWireType: 'Yangi sim turi qo\'shish',
    createWireType: 'Yangi sim turini yaratish',
    wireTypeName: 'Sim turi nomi',
    wireTypePlaceholder: 'masalan, Mis, Alyuminiy',
    noWireTypesFound: 'Sim turlari topilmadi.',
    totalWireTypes: 'Jami: {{count}} sim turi',
    id: 'ID',
    deleteColor: 'Rangni o\'chirish',
    deleteColorConfirm: '{{name}} rangini o\'chirishni xohlaysizmi?. Bu amalni bekor qilib bo\'lmaydi.',
    deleteWireType: 'Sim turini o\'chirish',
    deleteWireTypeConfirm: '{{name}} sim turini o\'chirishni xohlaysizmi?. Bu amalni bekor qilib bo\'lmaydi.',
  },

  // Material Incomes
  materialIncomes: {
    title: 'Material kirimlar',
    totalIncomes: 'Jami kirimlar',
    totalWeight: 'Jami og\'irlik',
    totalCost: 'Jami narx',
    totalLeftPrice: 'Jami qoldiq',
    manageIncomes: 'Material kirimlarini boshqarish va ko\'rish',
    addIncome: 'Kirim qo\'shish',
    createIncome: 'Material kirimi yaratish',
    createIncomeDesc: 'Yangi material kirimi yozuvini yaratish',
    selectMaterial: 'Materialni tanlang',
    quantity: 'Miqdor (kg)',
    enterQuantity: 'Miqdorni kiriting',
    pricePerKg: 'Har bir kg narxi',
    enterPrice: 'Narxni kiriting',
    enterGivenMoney: 'Berilgan summani kiriting',
    searchPlaceholder: 'Material, rang, tur yoki yetkazib beruvchi bo\'yicha qidirish...',
    materialName: 'Material nomi',
    kg: 'Kg',
    perKg: 'Har kg uchun',
    noIncomesFound: 'Material kirimlar topilmadi.',
    noIncomesMatch: 'Filtrlarga mos material kirimlar topilmadi.',
    showingIncomes: '{{count}} dan {{total}} kirim ko\'rsatilmoqda',
    creating: 'Yaratilmoqda...',
    // Form fields
    wireName: 'Sim nomi',
    enterWireName: 'Sim nomini kiriting',
    color: 'Rang',
    selectColor: 'Rangni tanlang',
    wireType: 'Sim turi',
    selectWireType: 'Sim turini tanlang',
    thickness: 'Qalinlik (mm)',
    supplier: 'Yetkazib beruvchi',
    enterSupplier: 'Yetkazib beruvchini kiriting',
    arrivalDate: 'Kelish sanasi',
    // Table headers
    material: 'Material',
    type: 'Turi',
    weight: 'Og\'irlik',
    priceKg: 'Narx/kg',
    fullPrice: 'To\'liq narx',
    leftPrice: 'Qoldiq to\'lov',
    givenMoney: 'To\'langan',
    arrived: 'Kelgan',
    actions: 'Amallar',
    // Add given money
    addGivenMoney: 'Berilgan summa qo\'shish',
    addGivenMoneyDesc: '{{material}} material uchun berilgan summa qo\'shish',
    amount: 'Summa',
    invalidGivenMoneyAmount: 'Summa musbat raqam bo\'lishi kerak',
    // Filters
    allColors: 'Barcha ranglar',
    allTypes: 'Barcha turlar',
    // Delete dialog
    deleteTitle: 'Material kirimini o\'chirish',
    deleteDescription: 'Ushbu material kirimi yozuvini o\'chirmoqchimisiz:',
    deleteWarning: 'Bu amalni bekor qilib bo\'lmaydi.',
  },

  // Pricing
  pricing: {
    title: 'Narxlash',
    addSellType: 'Sotish turini qo\'shish',
    createSellingType: 'Sotish turini yaratish',
    addWirePrice: 'Sim narxini qo\'shish',
    createWirePrice: 'Sim narxini yaratish',
    wireName: 'Nomi (Sim)',
    wireSquare: 'Katak',
    wireThickness: 'Qalinlik (mm)',
    wireWeight: 'Og\'irlik (Kg)',
    wirePrice: 'Narx',
    showingCombinations: '{{wires}} sim narxi × {{types}} sotish turi = {{total}} mumkin bo\'lgan kombinatsiya ({{configured}} sozlangan)',
    doubleClickToEdit: 'Tahrirlash uchun ikki marta bosing',
    doubleClickToAdd: 'Qo\'shish uchun ikki marta bosing',
    katak: 'Katak',
    sim: 'Sim',
    formula: 'Formula',
    kg: 'Kg',
    narx135: 'Jami Narx',
    narx: 'Narx',
    foyda: 'Foyda',
    delete: 'O\'chirish',
    budgetCalcPrices: 'Budget hisoblash narxlari',
    product: 'Mahsulot',
    material: 'Materiallar',
  },

  // Expenses
  expenses: {
    title: 'Xarajatlar',
    companyExpenses: 'Kompaniya xarajatlari',
    personalExpenses: 'Shaxsiy xarajatlar',
    totalExpenses: 'Jami xarajatlar',
    totalIncome: 'Jami daromad',
    balance: 'Balans',
    addExpense: 'Xarajat qo\'shish',
    addNewExpense: 'Yangi xarajat qo\'shish',
    createExpense: 'Xarajat yaratish',
    createNewExpense: 'Yangi daromad yoki xarajat yaratish',
    createPersonalExpense: 'Shaxsiy xarajat qo\'shish',
    createPersonalExpenseDesc: 'Yangi shaxsiy daromad yoki xarajat yaratish',
    manageExpenses: 'Kompaniya daromad va xarajatlarini boshqarish',
    managePersonalExpenses: 'Shaxsiy daromad va xarajatlarini boshqarish',
    category: 'Kategoriya',
    selectCategory: 'Kategoriyani tanlang',
    enterDescription: 'Tavsifni kiriting...',
    enterAmount: 'Miqdorni kiriting',
    searchPlaceholder: 'Tavsif, admin, miqdor bo\'yicha qidirish...',
    allCategories: 'Barcha kategoriyalar',
    allTypes: 'Barcha turlar',
    noExpensesFound: 'Xarajatlar topilmadi. "Xarajat qo\'shish" tugmasini bosing.',
    noExpensesFoundPersonal: 'Shaxsiy xarajatlar topilmadi. "Xarajat qo\'shish" tugmasini bosing.',
    noExpensesMatch: 'Filtrlarga mos xarajatlar topilmadi.',
    showingExpenses: '{{count}} dan {{total}} xarajat ko\'rsatilmoqda',
    selectWorker: 'Ishchini tanlang',
    loadingWorkers: 'Ishchilar yuklanmoqda...',
    selectOrder: 'Buyurtmani tanlang',
    loadingOrders: 'Buyurtmalar yuklanmoqda...',
    revenueType: 'Daromad turi',
    selectType: 'Turni tanlang',
    income: 'Daromad',
    expense: 'Xarajat',
    expenseType: 'Xarajat turi',
    company: 'Kompaniya',
    salary: 'Maosh',
    order: 'Buyurtma',
    worker: 'Ishchi',
    material: 'Material',
    type: 'Turi',
    admin: 'Admin',
    descriptionOptional: 'Tavsif (ixtiyoriy)',
    other: 'Boshqa',
    backToExpenses: 'Xarajatlarga qaytish',
    backToPersonalExpenses: 'Shaxsiy xarajatlarga qaytish',
    expenseNumber: 'Xarajat #{{id}}',
    personalExpenseNumber: 'Shaxsiy xarajat #{{id}}',
    noDescription: 'Tavsif kiritilmagan',
    deleteExpense: 'Xarajatni o\'chirish',
    deletePersonalExpense: 'Shaxsiy xarajatni o\'chirish',
    deleteConfirmation: 'Haqiqatan ham bu xarajatni o\'chirmoqchimisiz? Bu amalni bekor qilib bo\'lmaydi.',
    deletePersonalConfirmation: 'Haqiqatan ham bu shaxsiy xarajatni o\'chirmoqchimisiz? Bu amalni bekor qilib bo\'lmaydi.',
    relatedInfo: 'Bog\'liq ma\'lumotlar',
    createdBy: 'Yaratuvchi',
    timestamps: 'Vaqt belgilari',
    created: 'Yaratilgan',
    lastUpdated: 'Oxirgi yangilanish',
    expenseNotFound: 'Xarajat topilmadi',
    amount: 'Miqdor',
    description: 'Tavsif',
    date: 'Sana',
  },

  // Profile
  profile: {
    title: 'Profil',
    personalInfo: 'Shaxsiy ma\'lumotlar',
    manageInfo: 'Shaxsiy ma\'lumotlaringizni boshqaring',
    firstName: 'Ism',
    lastName: 'Familiya',
    email: 'Elektron pochta',
    phone: 'Telefon',
    avatar: 'Avatar',
    changeAvatar: 'Avatarni o\'zgartirish',
    editProfile: 'Tahrirlash',
    cancel: 'Bekor qilish',
    saveChanges: 'O\'zgarishlarni saqlash',
    saving: 'Saqlanmoqda...',
    selectLanguage: 'Interfeys tilini tanlang',
    emailCannotChange: 'Emailni o\'zgartirib bo\'lmaydi',
    accountCreated: 'Hisob yaratilgan',
    lastUpdated: 'Oxirgi yangilanish',
    updateSuccess: 'Profil muvaffaqiyatli yangilandi',
    unableToLoad: 'Profilni yuklab bo\'lmadi',
    joined: 'Qo\'shilgan',
  },

  // Detail pages
  detail: {
    back: 'Orqaga',
    orderDetails: 'Buyurtma tafsilotlari',
    workerDetails: 'Ishchi tafsilotlari',
    customerDetails: 'Mijoz tafsilotlari',
    expenseDetails: 'Xarajat tafsilotlari',
    transactions: 'Tranzaksiyalar',
    noTransactions: 'Tranzaksiyalar topilmadi',
    addTransaction: 'Tranzaksiya qo\'shish',
    addPayment: 'To\'lov qo\'shish',
    paymentAmount: 'To\'lov miqdori',
    notes: 'Izohlar',
    createdAt: 'Yaratilgan vaqti',
    updatedAt: 'Yangilangan vaqti',
  },

  // Unauthorized
  unauthorized: {
    title: 'Ruxsat yo\'q',
    message: 'Ushbu sahifaga kirish uchun sizda ruxsat yo\'q.',
    goBack: 'Orqaga qaytish',
    goToLogin: 'Kirish sahifasiga o\'tish',
  },

  // Statuses
  status: {
    active: 'Faol',
    inactive: 'Faol emas',
    pending: 'Kutilmoqda',
    accepted: 'Qabul qilindi',
    rejected: 'Rad etildi',
    new: 'Yangi',
    in_progress: 'Jarayonda',
    completed: 'Bajarildi',
    cancelled: 'Bekor qilindi',
    pendingApproval: 'Tasdiqlash kutilmoqda',
  },

  // Errors
  errors: {
    failedToLoad: 'Ma\'lumotlarni yuklashda xatolik',
    failedToCreate: 'Yaratishda xatolik',
    failedToUpdate: 'Yangilashda xatolik',
    failedToDelete: 'O\'chirishda xatolik',
    failedToLoadWorkers: 'Ishchilarni yuklashda xatolik',
    failedToLoadCustomers: 'Mijozlarni yuklashda xatolik',
    failedToLoadOrders: 'Buyurtmalarni yuklashda xatolik',
    failedToLoadProducts: 'Mahsulotlarni yuklashda xatolik',
    failedToLoadMaterials: 'Materiallarni yuklashda xatolik',
    failedToLoadPrices: 'Narxlarni yuklashda xatolik',
    failedToUpdatePriceRef: 'Narx ma\'lumotnomasini yangilashda xatolik',
    failedToDeletePriceRef: 'Narx ma\'lumotnomasini o\'chirishda xatolik',
    unauthorized: 'Ruxsat yo\'q',
    networkError: 'Tarmoq xatoligi',
  },

  // Language
  language: {
    title: 'Til',
    uz: 'O\'zbekcha',
    ru: 'Ruscha',
  },

  // Available Products (public)
  availableProducts: {
    title: 'Mavjud mahsulotlar',
    description: 'Ombordagi mavjud mahsulotlarni ko\'rish',
    productTypes: 'Mahsulot turlari',
    totalCount: 'Jami soni',
    totalWeight: 'Jami og\'irlik',
    inventoryTitle: 'Mahsulotlar katalogi',
    inventoryDescription: 'O\'lchamlari va mavjudligi bilan mahsulotlar',
    searchPlaceholder: 'O\'lchamlar bo\'yicha qidirish...',
    thickness: 'Qalinlik',
    cell: 'Katak',
    height: 'Balandlik',
    width: 'Kenglik',
    count: 'Soni',
    weight: 'Og\'irlik',
    allCells: 'Barcha kataklar',
    noProductsFound: 'Mahsulotlar topilmadi.',
    noProductsMatch: 'Filtrlarga mos mahsulotlar topilmadi.',
    contactInfo: 'Buyurtma uchun biz bilan bog\'laning',
    request: 'Buyurtma',
    requestTitle: 'Ariza yuborish',
    requestDescription: 'Mahsulotga ariza yuborish uchun formani to\'ldiring',
    productInfo: 'Mahsulot ma\'lumotlari',
    available: 'Mavjud',
    quantity: 'Miqdor',
    quantityPlaceholder: 'Miqdorni kiriting',
    phoneNumber: 'Telefon raqami',
    sendRequest: 'Ariza yuborish',
    requestSuccess: 'Ariza yuborildi!',
    requestSuccessMessage: 'Buyurtmani tasdiqlash uchun tez orada siz bilan bog\'lanamiz.',
    invalidQuantity: 'Iltimos, to\'g\'ri miqdorni kiriting',
    quantityExceedsStock: 'Miqdor mavjud qoldiqdan oshib ketdi',
    requestFailed: 'Arizani yuborib bo\'lmadi. Qaytadan urinib ko\'ring.',
    // Custom product request
    customRequest: 'Mahsulot buyurtma qilish',
    customRequestTitle: 'O\'lchamlar bo\'yicha mahsulot buyurtma qilish',
    customRequestDescription: 'Kerakli o\'lchamdagi mahsulotni buyurtma qilish uchun formani to\'ldiring',
    customRequestButton: 'Buyurtma berish',
    enterThickness: 'Qalinlikni kiriting',
    enterCell: 'Katakni kiriting',
    enterHeight: 'Balandlikni kiriting',
    enterWidth: 'Kenglikni kiriting',
    enterQuantity: 'Miqdorni kiriting',
    allFieldsRequired: 'Iltimos, barcha maydonlarni to\'ldiring',
    invalidValues: 'Barcha qiymatlar musbat raqam bo\'lishi kerak',
  },

  // Sell
  sell: {
    title: 'Sotuvlar',
    addSale: 'Yangi savdo',
    totalSales: 'Jami sotuvlar',
    totalRevenue: 'Jami daromad',
    totalProfit: 'Jami foyda',
    salesHistory: 'Sotuvlar tarixi',
    salesDescription: 'Sotuv yozuvlarini ko\'rish va boshqarish',
    searchPlaceholder: 'Material, sotuvchi bo\'yicha qidirish...',
    material: 'Material',
    cell: 'Katak',
    height: 'Balandlik',
    width: 'Kenglik',
    quantity: 'Miqdor',
    price: 'Narx',
    profit: 'Foyda',
    createdBy: 'Sotuvchi',
    date: 'Sana',
    noSalesFound: 'Sotuvlar topilmadi.',
    noSalesMatch: 'Filtrlarga mos sotuvlar topilmadi.',
    createSale: 'Sotuv yaratish',
    createDescription: 'Yangi sotuv yozuvini yaratish uchun ma\'lumotlarni kiriting',
    selectProduct: 'Mahsulotni tanlang',
    selectProductPlaceholder: 'Mahsulotni tanlang...',
    noProductsAvailable: 'Mavjud mahsulotlar yo\'q',
    selectedProduct: 'Tanlangan mahsulot',
    available: 'Mavjud',
    quantityPlaceholder: 'Miqdorni kiriting',
    loadProductsFailed: 'Mahsulotlarni yuklab bo\'lmadi',
    invalidQuantity: 'Noto\'g\'ri miqdor',
    invalidProfit: 'Foyda raqam bo\'lishi kerak.',
    createFailed: 'Sotuvni yaratib bo\'lmadi. Qaytadan urinib ko\'ring.',
    // Stock errors
    insufficientStockWeight: 'Ko\'rsatilgan mahsulot uchun omborda yetarli og\'irlik yo\'q.',
    insufficientStockQuantity: 'Ko\'rsatilgan mahsulot uchun omborda yetarli miqdor yo\'q.',
    productNotInSellingType: 'Tanlangan mahsulot tanlangan sotish turida mavjud emas.',
    // Price preview
    pricePreview: 'Narx oldindan ko\'rish',
    kg: 'Og\'irlik',
    inputData: 'Kiritilgan ma\'lumotlar',
    customerGivenPrice: 'Mijoz to\'lovi',
    // Delete
    deleteConfirmation: '"{{material}}" ({{cell}} katak) sotuvini o\'chirmoqchimisiz? Bu amalni bekor qilib bo\'lmaydi.',
  },
}
